(function () {
  'use strict';

  var config = window.ShopifyChatInstantAnswers;
  if (!config || !config.enabled || !Array.isArray(config.rules)) {
    return;
  }

  var CHAT_SELECTORS = ['inbox-online-store-chat', '#ShopifyChat'];
  var PROMPT_SELECTOR = '.instant-answers-list__prompt';
  var LIST_SELECTOR = '.interstitial-view__instant-answers-list';
  var HEADER_SELECTOR = 'h3.instant-answers';

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function productInAnyCollection(collectionHandles, productCollections) {
    for (var i = 0; i < collectionHandles.length; i++) {
      if (productCollections.indexOf(collectionHandles[i]) !== -1) {
        return true;
      }
    }

    return false;
  }

  function matchesAnyCollection(collectionHandles, productCollections, pageCollection) {
    for (var i = 0; i < collectionHandles.length; i++) {
      var handle = collectionHandles[i];
      if (productCollections.indexOf(handle) !== -1 || pageCollection === handle) {
        return true;
      }
    }

    return false;
  }

  function isTemplate(page, templateName) {
    return (page.template || '').split('.')[0] === templateName;
  }

  function isProductPage(page) {
    return isTemplate(page, 'product');
  }

  function isStorePage(page) {
    return isTemplate(page, 'page');
  }

  function normalizePageHandle(value) {
    var line = (value || '').trim();
    if (!line) {
      return '';
    }

    var match = line.match(/\/pages\/([^/?#]+)/i);
    if (match) {
      return match[1].toLowerCase();
    }

    return line.replace(/^\/+|\/+$/g, '').toLowerCase();
  }

  function pageInList(pageHandles, currentPageHandle) {
    var normalizedCurrent = normalizePageHandle(currentPageHandle);

    for (var i = 0; i < pageHandles.length; i++) {
      if (normalizePageHandle(pageHandles[i]) === normalizedCurrent) {
        return true;
      }
    }

    return false;
  }

  function matchesConfiguredPages(rule, page) {
    var pageHandles = rule.pages || [];
    if (!pageHandles.length) {
      return false;
    }

    return isStorePage(page) && pageInList(pageHandles, page.pageHandle || '');
  }

  function matchesConfiguredCollections(rule, page) {
    var collectionHandles = rule.collections || [];
    if (!collectionHandles.length) {
      return false;
    }

    var productCollections = page.productCollections || [];
    var pageCollection = page.collectionHandle || '';

    if (rule.productPagesOnly) {
      return isProductPage(page) && productInAnyCollection(collectionHandles, productCollections);
    }

    return matchesAnyCollection(collectionHandles, productCollections, pageCollection);
  }

  function pageMatchesRule(rule, page) {
    return matchesConfiguredCollections(rule, page) || matchesConfiguredPages(rule, page);
  }

  function ruleHasCriteria(rule) {
    var hasCollections = rule.collections && rule.collections.length;
    var hasPages = rule.pages && rule.pages.length;
    return !!(rule.prompt && (hasCollections || hasPages));
  }

  function pageUsesManagedInstantAnswers(page, rules) {
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!ruleHasCriteria(rule)) {
        continue;
      }

      if (matchesConfiguredCollections(rule, page) || matchesConfiguredPages(rule, page)) {
        return true;
      }
    }

    return false;
  }

  function findMatchingRule(promptText, rules) {
    var normalizedPrompt = normalizeText(promptText);

    for (var i = 0; i < rules.length; i++) {
      if (normalizeText(rules[i].prompt) === normalizedPrompt) {
        return rules[i];
      }
    }

    return null;
  }

  function shouldShowPrompt(promptText, rules, page) {
    var matchingRule = findMatchingRule(promptText, rules);

    if (matchingRule && ruleHasCriteria(matchingRule)) {
      return pageMatchesRule(matchingRule, page);
    }

    if (pageUsesManagedInstantAnswers(page, rules)) {
      return false;
    }

    return true;
  }

  function filterInstantAnswers(shadowRoot) {
    var prompts = shadowRoot.querySelectorAll(PROMPT_SELECTOR);
    if (!prompts.length) {
      return;
    }

    prompts.forEach(function (button) {
      var textNode = button.querySelector('p');
      var promptText = textNode ? textNode.textContent : button.textContent;
      var show = shouldShowPrompt(promptText, config.rules, config.page);

      button.hidden = !show;
      button.style.display = show ? '' : 'none';
      button.setAttribute('aria-hidden', show ? 'false' : 'true');
    });

    var list = shadowRoot.querySelector(LIST_SELECTOR);
    if (!list) {
      return;
    }

    var hasVisiblePrompt = Array.prototype.some.call(prompts, function (button) {
      return !button.hidden;
    });

    var header = list.querySelector(HEADER_SELECTOR);
    if (header) {
      header.hidden = !hasVisiblePrompt;
      header.style.display = hasVisiblePrompt ? '' : 'none';
    }

    list.hidden = !hasVisiblePrompt;
    list.style.display = hasVisiblePrompt ? '' : 'none';
  }

  function getChatHost() {
    for (var i = 0; i < CHAT_SELECTORS.length; i++) {
      var host = document.querySelector(CHAT_SELECTORS[i]);
      if (host) {
        return host;
      }
    }

    return null;
  }

  function init() {
    var attempts = 0;
    var maxAttempts = 60;

    var waitForChat = window.setInterval(function () {
      attempts += 1;
      var chatHost = getChatHost();

      if (!chatHost || !chatHost.shadowRoot) {
        if (attempts >= maxAttempts) {
          window.clearInterval(waitForChat);
        }
        return;
      }

      window.clearInterval(waitForChat);
      filterInstantAnswers(chatHost.shadowRoot);

      var observer = new MutationObserver(function () {
        filterInstantAnswers(chatHost.shadowRoot);
      });

      observer.observe(chatHost.shadowRoot, {
        childList: true,
        subtree: true
      });
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
